<div>
  <xng-breadcrumb [autoGenerate]="false"></xng-breadcrumb>

  <!-- <ng-template #iconTemplate>
    <span class="material-icons"> keyboard_arrow_right </span>
  </ng-template> -->
</div>
